<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="soas"
        @select="selectHandle"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            :loading="submitLoading"
            :disabled="scope.row.status !==0"
            type="primary"
            @click="submit(scope.row)">
          提交
        </el-button>
<!--        <el-button type="primary" @click="createInvoice(scope.row)">开票</el-button>-->
      </template>>
      <template slot="otherBtn">
        <el-button
            v-if="limits.cloudStatusAuth"
            :disabled="selection.length !==1"
            type="success"
            :loading="updateStatusLoading"
            @click="updateCloudStatus(selection)">
          云报账同步
        </el-button>
        <el-button
            v-if="limits.cloudEdith"
            :disabled="selection.length !==1"
            type="primary"
            @click="cloudEdit(selection)">
          编辑
        </el-button>
        <el-button
            v-if="limits.submitCloud"
            :loading="submitToCloudLoading"
            :disabled="selection.length !==1"
            type="success"
            @click="submitToCloud(selection)">
          提交云报账
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="对账单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入对账单号" clearable/>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input v-model.trim="filter.purchaseReceiveNo" placeholder="请输入送货单号" clearable/>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.sapPurchaseOrderNo" placeholder="请输入采购单号" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </el-form-item>
          <el-form-item label="MES状态">
            <el-select v-model="filter.statusName" clearable placeholder="请选择MES状态">
              <el-option label="全部" value=""/>
              <el-option label="草稿" value="草稿"/>
              <el-option label="财务确认发票信息" value="财务确认发票信息"/>
              <el-option label="采购确认发票信息" value="采购确认发票信息"/>
              <el-option label="采购确认开票申请" value="采购确认开票申请"/>
              <el-option label="供应商开票" value="供应商开票"/>
              <el-option label="已完成" value="已完成"/>
            </el-select>
          </el-form-item>
          <el-form-item label="云报账状态">
            <el-select v-model="filter.cloudSoaStatus" placeholder="请选择云报账状态" clearable>
              <el-option label="已结束" value="9"/>
              <el-option label="未知" value="-1"/>
              <el-option label="单据草稿" value="1"/>
              <el-option label="待清欠处理" value="20"/>
              <el-option label="待审批流发起" value="24"/>
              <el-option label="审批流发起失败" value="25"/>
              <el-option label="业务审批中" value="30"/>
              <el-option label="预算使用中" value="31"/>
              <el-option label="待影像处理" value="35"/>
              <el-option label="影像处理中" value="40"/>
              <el-option label="待单据推送共享" value="45"/>
              <el-option label="共享审批中" value="50"/>
              <el-option label="共享已审批" value="60"/>
              <el-option label="已撤回" value="70"/>
              <el-option label="业务审批退回" value="80"/>
              <el-option label="共享审批退回" value="85"/>
              <el-option label="影像退回" value="90"/>
              <el-option label="待发票后补" value="91"/>
              <el-option label="退回至业务系统" value="94"/>
              <el-option label="待支付" value="0"/>
              <el-option label="支付退回" value="2"/>
              <el-option label="支付退汇" value="3"/>
              <el-option label="支付中" value="4"/>
              <el-option label="支付退回" value="6"/>
              <el-option label="已作废" value="8"/>
              <el-option label="部分支付" value="110"/>
              <el-option label="支付挂起" value="111"/>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="filter.consignment" clearable placeholder="请选择类型">
              <el-option label="全部" value=""/>
              <el-option label="非寄售" value="非寄售"/>
              <el-option label="寄售" value="寄售"/>
            </el-select>
          </el-form-item>
          <el-form-item label="审批日期">
            <el-date-picker
                v-model="submitTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="submitTimeChange"/>
          </el-form-item>
        </el-form>
      </template>
    </viewtable>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ReconcileOrderEdit from "@/views/PurchaseOrderManager/ReconcileOrder/ReconcileOrderEdit";

  export default {
    name:"ReconcileOrderList",
    components: {ReconcileOrderEdit, viewTable},
    data() {
      return {
        limits: {
          editAuth: this.$auth(452),
          delAuth: this.$auth(454),
          subAuth: this.$auth(453),
          cloudStatusAuth: this.$auth(130),
          cloudEdith:this.$auth(131),
          submitCloud:this.$auth(132),
        },
        updateStatusLoading:false,
        submitToCloudLoading:false,
        submitTime:"",
        filter: {
          billNo: "",
          supplierName: "",
          supplierNo: "",
          status: "",
          statusName:"",
          purchaseReceiveNo:"",
          sapPurchaseOrderNo:"",
          buyUserName:"",
          consignment:"",
          cloudSoaStatus:"",
          submitDateBegin:"",
          submitDateEnd:"",
        },
        selection: [],
        arriveDate:"",
        createDate:"",
        submitLoading:false,
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/ReconcileOrderDetail",
                        query: {
                          billType: 27,
                          billId: params.row.pkId,
                          sequId: -1,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "asnRowIndex",
            width: 120,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.reconcileOrderEdit.open(1,row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        console.log(row);
        this.$http.delete("basic", "soas", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      arriveDateChange(value) {
        if (value) {
          this.filter.arriveDateBegin = value[0];
          this.filter.arriveDateEnd = value[1];
        } else {
          this.filter.arriveDateBegin = "";
          this.filter.arriveDateEnd = "";
        }
      },

      createDateChange(value) {
        if (value) {
          this.filter.createDateBegin = value[0];
          this.filter.createDateEnd = value[1];
        } else {
          this.filter.createDateBegin = "";
          this.filter.createDateEnd = "";
        }
      },

      submitTimeChange(date) {
        if (date !== null) {
          this.filter.submitDateBegin = date[0];
          this.filter.submitDateEnd = date[1];
        } else {
          this.filter.submitDateBegin = "";
          this.filter.submitDateEnd = "";
        }
      },

      submit(row) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.submitLoading = true;
          this.$http.post("basic", `soas/submit/${row.pkId}`).then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.$message.success("提交成功");
              this.loadData();
            }
          }).catch(()=>{
            this.submitLoading = false;
          });
        });
      },

      createInvoice(row) {
        this.$http.get("basic", `soas/createInvoice/${row.pkId}`).then((res) => {
          if (res.success) {
            this.submitLoading = false;
            this.$message.success("开票成功");
            this.loadData();
          }
        }).catch(()=>{
          this.submitLoading = false;
        });
      },

      cancelInvoice(row) {
        this.$http.get("basic", `soas/cancelInvoice/${row.pkId}`).then((res) => {
          if (res.success) {
            this.submitLoading = false;
            this.$message.success("冲销成功");
            this.loadData();
          }
        }).catch(()=>{
          this.submitLoading = false;
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return  false;
        } else {
          return  true;
        }
      },

      updateCloudStatus() {
        this.updateStatusLoading=true;
        let row=this.selection[0];
        this.$http.get("basic", `soas/queryCloudStatus/${row.pkId}`)
          .then((res) => {
            this.$message.success("更新成功");
          }).finally(()=>{
            this.updateStatusLoading=false;
            this.getList(1);
          });
      },

      cloudEdit() {
        let row=this.selection[0];
        this.$refs.reconcileOrderEdit.open(1, row);
      },

      submitToCloud() {
        this.submitToCloudLoading=true;
        let row=this.selection[0];
        this.$http.get("basic",`soas/submitToCloud/${row.pkId}`)
          .then((resp)=>{
            this.$message.success("更新成功");
            this.getList(1);
          }).finally(()=>{
            this.submitToCloudLoading=false;
          });
      },
    },
  };
</script>
